import { getChartDateFormat, getTickPositions, getValueOfToolTip, getXAxisTitleText, } from '@hems/user/src/containers/report/chartFunctions';
export function getConsumtionOptions(tabname, locale, data, t, isACSystem) {
    return {
        chart: {
            type: 'column',
            height: 480,
        },
        rangeSelector: {
            enabled: false,
        },
        title: {
            text: '',
        },
        credits: {
            enabled: false,
        },
        legend: {
            enabled: true,
            borderRadius: 0,
            itemMarginTop: 1,
            squareSymbol: true,
            symbolWidth: 4,
            symbolPadding: 10,
            verticalAlign: 'top',
            y: 10,
            symbolRadius: 0,
            itemStyle: {
                fontWeight: 'regular',
            },
        },
        yAxis: [
            {
                offset: 20,
                labels: {
                    style: {
                        color: '#434348',
                    },
                    formatter() {
                        return `${this.value}k`;
                    },
                },
                opposite: true,
                title: {
                    text: `${t('common.energy')}(Wh)`,
                    margin: 10,
                    style: {
                        color: '#434348',
                    },
                },
                min: 0,
                tickAmount: 6,
            },
        ],
        xAxis: [
            {
                title: {
                    text: getXAxisTitleText(tabname, t),
                    align: 'high',
                },
                labels: {
                    autoRotation: [0],
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
                tickPositions: getTickPositions(tabname, data.consumtionData.map((item) => item.x)),
            },
        ],
        tooltip: {
            shared: true,
            formatter() {
                return getValueOfToolTip(tabname, this, locale, t);
            },
            useHTML: true,
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                grouping: false,
            },
        },
        series: getConsumptionSeries(data, t, isACSystem),
        scrollbar: {
            enabled: true,
        },
        navigator: {
            xAxis: {
                labels: {
                    formatter() {
                        return getChartDateFormat(tabname, Number(this.value), locale);
                    },
                },
            },
        },
        noData: {
            position: {},
            attr: {},
            style: {
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#202030',
            },
        },
    };
}
function getConsumptionSeries(data, t, isACSystem) {
    const series = [];
    series.push({
        type: 'column',
        yAxis: 0,
        name: t('device.consumed'),
        color: '#b4b8bb',
        data: data.consumtionData,
    });
    if (!isACSystem) {
        series.push({
            type: 'column',
            name: t('device.core_load'),
            color: '#97b5cc',
            data: data.coreLoadData,
        });
    }
    return series;
}
